import React, {useEffect, useState} from 'react';
import SelectBoxDB from "../Componnets/SelectBoxDbName";
import IPInput from "../Componnets/IPInput";
import PasswordInput from "../Componnets/PasswordInput";
import {Redirect} from "react-router-dom";
import http from "../../services/api/utilities/http";

const errorStyle = {
    position: 'absolute',
    top: 87,
    color: 'red',
}

export default function DbInfo(props) {
  const [selected, setSelected] = useState(false);
  const [credential, setCredential] = useState(false);
  const [error, setError] = useState('');
  const [ip, setIp] = useState(''); //postgres
  const [port, setPort] = useState('');//5432
  const [loading, setLoading] = useState(false);
  const [database, setDatabase] = useState([]);
  const [username, setUsername] = useState('');
  const [databaseName, setDatabaseName] = useState('');
  const [dbUri, setDbUri] = useState('');
  const [password, setPassword] = useState('');//aJDd59e7rHl2zBrvvwCZP68G
  const [credentialError, setCredentialError] = useState('');//aJDd59e7rHl2zBrvvwCZP68G
  const [redirect, setRedirect] = useState(false);
  useEffect(() => {
    getDbList()
  }, [])
  const getDbList = () => {
    http.get('data_connector/data_source/')
      .then(res => {
        console.log('res', res)
        setDatabase(res.data.data)
      })
      .catch(err => {
        console.log(err.response)
      })
  }
  if (redirect)
    return <Redirect to='/data-connector/select-event-log'/>
  const changeDB = () => {
    setSelected(false)
    setCredential(false)
  }
  const selectDB = () => {
    setSelected(true)
  }
  const connectDB = () => {
    setError('')
    if (ip && port && !error) {
      setLoading(true)
      http.put('data_connector/data_source/', {
          data_base_uri: ip,
          data_base_port: port
        })
        .then(res => {
          console.log('res', res)
          setLoading(false)
          if (res.data.data.connectivity)
            setCredential(true)
          else
            setError('Connection Failed!')
        })
        .catch(err => {
          console.log(err.response)
          setLoading(false)
          setError('server IP or port is invalid')
        })
    } else
      setError('server IP or port is empty')
  }
  const reachDataBase = () => {
    http.post('data_connector/data_source/', {
        data_store_system: dbUri,
        data_base_uri: ip,
        data_base_port: port,
        database_user: username,
        database_name: databaseName,
        database_password: password
      })
      .then(res => {
        console.log('res', username, password)
        console.log('res', res.data.data)
        props.setUid(res.data.data.id)
        props.getTable(res.data.data)
        props.pushDBSource({type: 'Database', server: ip, name: 'event_log'})
        props.goToNext()
      })
      .catch(err => {
        console.log('dbUri', dbUri, 'port', port, 'username', username, 'password', password)
        console.log(err.response)
        setLoading(false)
      })
  }
  const portHandler = e => {
    setError('')
    setPort(e.target.value)
  }
  const credentialHandler = e => {
    const {value, name} = e.target
    setCredentialError('')
    if (name === 'username')
      setUsername(value)
    else if (name === 'password')
      setPassword(value)
    console.log(name)
  }
  return (
    <div style={{width: 839}}>
      <div className="row">
        <div className="col-12 db-info">
          <div className="d-flex bb pb-4">
            <div>
              <h6 className={credential && 'title-header-disable'}>Server Address</h6>
              <IPInput setIp={ip => setIp(ip)} setError={() => setError('')}/>
            </div>
            <div>
              <h6 className={credential && 'title-header-disable'}>Port</h6>
              <input style={{width: 198}} onChange={portHandler} className="mt-3" placeholder="Enter Server Port" type="text" disabled={credential ? true : false}/>
            </div>
            <div className="d-flex justify-content-end align-items-end">
              {credential
                ?
                <div onClick={() => setCredential(false)} className="btn btn-outline">
                  Change Server
                </div>
                :
                <div  onClick={connectDB} className={`${loading && 'btn-loading-small'} btn btn-by-loading btn-active`}>
                  <p>connect</p>
                  <p>connecting</p>
                </div>
              }
            </div>
            <p className="error" style={errorStyle}>{error}</p>
          </div>
          {credential
          &&
          <>
            <div className="mt-32">
              <h6>Credentials</h6>
              <p className="mt-2">To access your file we need your credentials</p>
            </div>
            <div className="d-flex row_3 mt-24">
              <div>
                <h6>Username</h6>
                <input name="username" onChange={credentialHandler} placeholder="Enter Your File Username"
                       className="mt-3" type="text"/>
              </div>
              <div className="mr-24">
                <h6>Password</h6>
                <PasswordInput placeHolder={'Enter Your File Password'} setPassword={credentialHandler}/>
              </div>

            </div>
            <div className="d-flex">
              <div>
                <h6 className="mt-24">Database Name</h6>
                <input name="databasename" onChange={e => setDatabaseName(e.target.value)} placeholder="Enter Your Database Name"
                       className="mt-3" type="text"/>
              </div>
              <div className="mr-24">
                <h6 className={`mt-24 ${selected && 'title-header-disable'}`}>Select Database Service</h6>
                <div className="d-flex align-items-center mt-3">
                  <SelectBoxDB setDbUri={uri => setDbUri(uri)} database={database} status={selected}/>
                </div>
              </div>
            </div>
              <div className="d-flex justify-content-start mt-24">
                  <div onClick={reachDataBase} className="btn">
                      CONNECT
                  </div>
              </div>
          </>
          }
        </div>
      </div>
    </div>

  );
}
